import * as d3 from 'd3';
import * as React from 'react';
import { observer } from 'mobx-react';
import { ITrajectoryAxisProps } from './ITrajectoryAxisProps';

@observer
export class TrajectoryAxis extends React.Component<ITrajectoryAxisProps> {
  private axisElement: SVGElement;

  constructor(props: ITrajectoryAxisProps) {
    super(props, undefined);
  }

  componentDidMount() {
    this.renderAxis();
  }

  componentDidUpdate() {
    this.renderAxis();
  }

  renderAxis() {
    // https://medium.com/@caspg/responsive-chart-with-react-and-d3v4-afd717e57583
    var axis = d3.select(this.axisElement).call(this.props.axis);
    if (!axis) {
      //hack
      console.log('axis null or undefined in TrajectoryAxis');
    }
  }
  render() {
    return (
      <g
        className={`Axis Axis-${this.props.orient} ${this.props.className}`}
        ref={(el: SVGAElement) => {
          this.axisElement = el;
        }}
        transform={this.props.translate}
      />
    );
  }
}
